import React from "react";
import axios from "axios";
import severUrl from "../../api";
import pdf from "../../assets/svgs/pdf.svg";
import youtube from "../../assets/svgs/youtube.svg";
import { HtmlBody } from "./HtmlBody";
import { HTML } from "./html";
import { MathComponent } from "mathjax-react";
import { TABLE } from "./table";
import Prism from "prismjs";
import "../../assets/css/prism.css";
import "../../assets/css/post.css";
import cmd from "../../assets/images/cmd.png";
import "prismjs/components/prism-python";
import ReactDOMServer from "react-dom/server";
import parse from "html-react-parser";
import { BlinkBlur } from "react-loading-indicators";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import Model from "./Video";
import MLModel from "./MLModel";

import GoogleAd from "../Adsense/GoogleAd";

const options = { //Typescript ways of adding the type
  year: "numeric",
  month: "long",
};

const inlineFormula = "\\cos (2\\theta) = \\cos^2 \\theta - \\sin^2 \\theta";
const blockFormula = `\\frac{n!}{k!(n-k)!} = \\binom{n}{k}`;

// "title":"How machine learning works"
// "slug":"01"
// "content":"The early stages of machine learning (ML) saw experiments involving theories of computers recognizing patterns in data and learning from them. Today, after building upon those foundational experiments, machine learning is more complex. While machine learning algorithms have been around for a long time, the ability to apply complex algorithms to big data applications more rapidly and effectively is a more recent development. Being able to do these things with some degree of sophistication can set a company ahead of its competitors."
// "updated_on":"2022-06-28T07:59:27.233624Z"
// "created_on":"2022-06-28T07:59:27.233676Z"
// "status":0

const TypeOfText = {
  0: "paragraph",
  1: "image",
  2: "header",
  3: "link",
  4: "citation",
  5: "appendix",
  6: "h1",
  7: "h2",
  8: "h3",
  9: "h4",
  10: "code",
  11: "ol",
  12: "video",
  13: "html",
  14: "mix",
  15: "math",
  16: "table",
  17: "img_src",
  18: "ver",
};
const TEXT_DECORATION = { 0: "Normal", 1: "Bold", 2: "Underline", 3: "Italic" };

// export const changeNewVersion = async (post_id) => {
//   try {
//     var bodyFormData = new FormData();
//     bodyFormData.append("post_id", post_id);
//     const resp = await axios.post(
//       "http://127.0.0.1:8000/blog/post/find/",
//       bodyFormData
//     );
//     console.log(post_id);
//     return resp;
//   } catch (err) {
//     // Handle Error Here
//     console.error(err);
//   }
// };

function AsyncCall() {
  return new Promise((resolve) => setTimeout(() => resolve(), 2500));
}

class Post1 extends React.Component {
  state = {
    created_on: "",
    title: "",
    slug: "",
    updated_on: "",
    status: "",
    appendix: "",
    text: "",
    styles: "",
    citation: "",
    views: "",
    eng_ver: null,
    lang: 0,
    pdf: "",
    video: "",
    previous: null,
    next: null,
    previous_title: "",
    next_title: "",
    loading: true,
    counter: 0,
    readyToTypeset: false,
    features: [],
    authors: [],
    modelLink: "",
    html: null,
    currVer: 1.0,
    mathjaxConfig: {
      startup: {
        ready: () => {
          window.MathJax.startup.defaultReady();
          this.setState({ readyToTypeset: true });
        },
      },
    },
    modelShow: false,
    copyText: "Copy",
    fvalues: [],
    predictValue: "",
    MLModelShow: false,
  };

  constructor(props) {
    super(props);
    this.onShow = this.onShow.bind(this);
    this.onMLShow = this.onMLShow.bind(this);
  }

  changeVersion = async () => {
    var bodyFormData = new FormData();
    bodyFormData.append("post_id", this.state.eng_ver);
    await axios
      .post(severUrl + `blog/post/find/`, bodyFormData, {
        headers: {
          "Content-Encoding": "gzip",
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({ content: data.content });
        this.setState({ created_on: data.post.created_on });
        this.setState({ title: data.post.title });
        this.setState({ views: data.post.total_visited });
        this.setState({ lang: data.post.lang });
        this.setState({ modelLink: data.post.modelLink });
        this.setState({ features: data.post.features });
        this.setState({ eng_ver: data.post.eng_ver });
        this.setState({ appendix: data.appendix });
        this.setState({ text: data.text });
        this.setState({ styles: data.styles });
        this.setState({ citation: data.citation });
        if (data.post.previous_post !== null) {
          this.setState({ previous_title: data.post.previous_post.title });
          this.setState({ previous: data.post.previous_post.slug });
        }
        if (data.post.next_post !== null) {
          this.setState({ next: data.post.next_post.slug });
          this.setState({ next_title: data.post.next_post.title });
        }
      });
  };

  componentDidMount() {

    Prism.highlightAll();
    // make fetch request
    this.state.counter > 0 &&
      setTimeout(
        () => this.setState({ counter: this.state.counter - 1 }),
        1000
      );
    fetch(severUrl + `blog/${this.props.data.slug}/`, {
      method: "GET",
      ContentEncoding: "gzip",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.html);
        console.log(data.post.authors);
        if (data.html) {
          this.setState({ loading: false });
          this.setState({ html: data.html.content });
          this.setState({ counter: 0 });
          this.setState({ created_on: new Date(data.post.updated_on).toLocaleDateString([], options)});
          this.setState({ title: data.post.title });
          this.setState({ views: data.post.total_visited });
          this.setState({ lang: data.post.lang });
          this.setState({ eng_ver: data.post.eng_ver });
          this.setState({ pdf: data.post.pdf });
          this.setState({ video: data.post.video });
          this.setState({ modelLink: data.post.modelLink });
          this.setState({ features: data.post.features });
          this.setState({ authors: data.post.authors });
          if (data.post.previous_post !== null) {
            this.setState({ previous_title: data.post.previous_post.title });
            this.setState({ previous: data.post.previous_post.slug });
          }
          if (data.post.next_post !== null) {
            this.setState({ next: data.post.next_post.slug });
            this.setState({ next_title: data.post.next_post.title });
          }
          const v = [];
          if (data.post.features) {
            for (let i = 0; i < data.post.features.length; i++) {
              v.push({ id: i, value: 0 });
            }
            this.setState({ fvalues: v });
          }
        } else {
          AsyncCall().then(() => this.setState({ loading: false }));
          this.setState({ counter: 0 });
          this.setState({ content: data.content });
          this.setState({ created_on: data.post.created_on });
          this.setState({ title: data.post.title });
          this.setState({ views: data.post.total_visited });
          this.setState({ lang: data.post.lang });
          this.setState({ eng_ver: data.post.eng_ver });
          this.setState({ appendix: data.appendix });
          this.setState({ text: data.text });
          this.setState({ citation: data.citation });
          this.setState({ styles: data.styles });
          this.setState({ pdf: data.post.pdf });
          this.setState({ video: data.post.video });
          this.setState({ modelLink: data.post.modelLink });
          this.setState({ features: data.post.features });
          if (data.post.previous_post !== null) {
            this.setState({ previous_title: data.post.previous_post.title });
            this.setState({ previous: data.post.previous_post.slug });
          }
          if (data.post.next_post !== null) {
            this.setState({ next: data.post.next_post.slug });
            this.setState({ next_title: data.post.next_post.title });
          }
          const v = [];
          if (data.post.features) {
            for (let i = 0; i < data.post.features.length; i++) {
              v.push({ id: i, value: 0 });
            }
            this.setState({ fvalues: v });
          }
        }
      });
    // }

    window.MathJax = this.state.mathjaxConfig;
    let script = document.createElement("script");
    script.defer = true;
    script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";
    document.head.appendChild(script);
    // const htmlString = ReactDOMServer.renderToString(this)
    // console.log(htmlString)

    const script1 = document.createElement("script1");
    script1.src = '../../copy.js';
    script1.async = true;
    script1.defer = true;
    document.body.appendChild(script1);

  }

  componentDidUpdate() {
    if (this.state.readyToTypeset) {
      window.MathJax.typesetPromise();
    }
    Prism.highlightAll();
  }

  copyText(content) {
    navigator.clipboard.writeText(content);
    this.setState({ copyText: "Done" });
    setTimeout(() => {
      this.setState({ copyText: "Copy" });
    }, 2000);
  }

  onShow() {
    this.setState({ modelShow: !this.state.modelShow });
    document.body.style.overflow = !this.state.modelShow ? "hidden" : "scroll";
  }

  onMLShow() {
    this.setState({ MLModelShow: !this.state.MLModelShow });
    document.body.style.overflow = !this.state.MLModelShow
      ? "hidden"
      : "scroll";
  }

  render() {
    const {
      next,
      previous,
      next_title,
      previous_title,
      loading,
      modelShow,
      video,
    } = this.state;

    if (loading) {
      return (
        <>
          <div
            style={{
              justifyContent: "center",
              textAlign: "center",
              width: "100%",
              marginTop:"30%"
            }}
          >
            {/* <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div> */}

            <BlinkBlur color="#32cd32" size="medium" text="" textColor="" />
          </div>
        </>
      );
    }
    return (
      <>
      
        {modelShow && <Model hide={this.onShow} link={video} />}
        {this.state.MLModelShow && (
          <MLModel
            hide={this.onMLShow}
            link={this.state.modelLink}
            features={this.state.features}
          />
        )}
        <div className="Head_post" >
        {(previous || next) && (
          <div
            style={{
              alignItems: "center",
              marginBottom: "0px",
              width: "100%",
              paddingBottom: "0px",
              height: "80px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {previous && (
              <a
                style={{
                  fontSize: "14px",
                  width: "50%",
                  alignItems: "start",
                  alignContent: "start",
                  fontWeight: "450",
                  color: "white",
                }}
                href={"/" + previous}
              >
                {previous_title}
              </a>
            )}
            {next && (
              <a
                style={{
                  fontSize: "14px",
                  width: "50%",
                  alignItems: "end",
                  alignContent: "end",
                  textAlign: "end",
                  fontWeight: "450",
                  color: "white",
                }}
                href={"/" + next}
              >
                <p>{next_title}</p>
              </a>
            )}
          </div>
        )}
          <div
            style={{
              fontSize: "calc(10px + .390625vw)",
              width: "100%",
              color: "white",
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              margin: "0.5rem 0 0 0",
            }}
          >
            {this.state.created_on}
          </div>
          <p className="big-title">{this.state.title}</p></div>
        {/* <p>{this.state.created_on + `: Initial version`}</p> */}
        {this.state.authors.length != 0 && <p style={{marginTop: "20px", fontWeight: "bold"}}>{'Helped by: ' + this.state.authors}</p>}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
            textAlign: "center",
            paddingTop:"1em",
            paddingBottom:"1em",
            // marginBottom: "20px",
          }}
        >
          {severUrl === "http://127.0.0.1:8000/" && (
            <>
              <a
                style={{ width: "20px", margin: "0 10px 0 10px" }}
                href={"http://127.0.0.1:8000/" + this.state.pdf}
              >
                <img alt="pdf file" src={pdf}></img>
              </a>
              <button label="u" onClick={this.onShow}>
                <img
                  alt="Video link"
                  style={{
                    height: "20px",
                    border: "none",
                    backgroundColor: "transparent",
                    margin: "0 10px 0 10px",
                  }}
                  src={youtube}
                ></img>
              </button>
            </>
          )}

          {severUrl !== "http://127.0.0.1:8000/" && (
            <>
              <a href={this.state.pdf}>
                <img alt="pdf file"
                  style={{ width: "25px", marginRight: "5px" }}
                  src={pdf}
                ></img>
              </a>
              <button
                style={{
                  height: "40px",
                  border: "none",
                  backgroundColor: "transparent",
                }}
                onClick={this.onShow}
              >
                <img
                  alt="Youtube link"
                  style={{
                    width: "25px",
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                  src={youtube}
                ></img>
              </button>
            </>
          )}

          {this.state.modelLink !== "" && this.state.modelLink && (
            <>
              <button
                label="commsndBtn"
                style={{
                  width: "25px",
                  border: "none",
                  backgroundColor: "transparent",
                  margin: "0 10px 0 10px",
                }}
                onClick={this.onMLShow}
              >
                <img
                  alt="Command"
                  style={{
                    maxWidth: "25px",
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                  src={cmd}
                ></img>
              </button>
            </>
          )}
          {this.state.eng_ver && (
            <button
              onClick={this.changeVersion}
              style={{
                width: "fit-content",
                margin: "10px",
                marginBottom: "20px",
              }}
            >
              {this.state.lang === 0 ? "Read ENG" : "Read VIE"}
            </button>
          )}
        </div>
        {this.state.html && parse(this.state.html)}
        {/* {this.state.html &&   <div dangerouslySetInnerHTML={{ __html: this.state.html }} />} */}
        {this.state.html == null && (
          <>
            {Array.from(this.state.appendix).map(
              ({ text, indentLevel, link }) => (
                <>
                  <a className="table_link" href={link}>
                    <p
                      className="table_content"
                      style={{ textIndent: String(indentLevel) + "px" }}
                    >
                      {text}
                    </p>
                  </a>
                </>
              )
            )}
            <br />
            <span class="br"></span>
            {Array.from(this.state.text).map(
              ({ content, cssId, role, image }, index) => (
                <>
                  {TypeOfText[role] === "h2" && (
                    <>
                      <div className="h2_text" id={cssId}>
                        {content}
                      </div>
                      <br />
                    </>
                  )}
                  {TypeOfText[role] === "ver" && (
                    <>
                      <div>{content}</div>
                      <br />
                    </>
                  )}
                  {TypeOfText[role] === "h3" && (
                    <>
                      <div className="h3_text" id={cssId}>
                        {content}
                      </div>
                      <br />
                    </>
                  )}
                  {TypeOfText[role] === "paragraph" && (
                    <>
                      <p id={cssId}>
                        {content}
                      </p>
                    </>
                  )}
                  {TypeOfText[role] === "table" && (
                    <>
                      <TABLE content={content} />
                      <br />
                    </>
                  )}
                  {TypeOfText[role] === "img_src" && (
                    <>
                      <div
                        style={{ textAlign: "center", padding: "5px 0 5px 0" }}
                      >
                        <img
                          alt="IMG"
                          src={content}
                          style={{
                            width: "fit-content",
                            height: "200px",
                            textAlign: "center",
                          }}
                        />
                      </div>
                    </>
                  )}
                  {TypeOfText[role] === "math" && (
                    <>
                      <MathComponent tex={content} />
                    </>
                  )}
                  {TypeOfText[role] === "code" && (
                    <>
                      <div
                        style={{
                          padding: "8px 14px",
                          wordWrap: "break-word",
                        }}
                      >
                        <pre style={{ wordWrap: "break-word" }}>
                          <code
                            class="language-python"
                            style={{
                              padding: "8px 14px",
                              wordWrap: "break-word",
                              whiteSpace: "pre-line",
                              fontSize:"12px",
                              //lineHeight: "1.4"
                            }}
                          >
                            {content.replace(/(?:\r\n|\r|\n)/g, '')}
                          </code>
                        </pre>
                      </div>
                      <br />
                    </>
                  )}
                  {TypeOfText[role] === "image" && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "5px 0 5px 0",
                        }}
                      >
                        <figure
                          style={{
                            width: "100%",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          {severUrl === "http://127.0.0.1:8000/" && (
                            <img
                              alt="IMG"
                              style={{
                                maxWidth: "50%",
                                width: "100%",
                                height: "fit-content",
                              }}
                              loading="lazy"
                              src={severUrl + image}
                            ></img>
                          )}
                          {severUrl !== "http://127.0.0.1:8000/" && (
                            <img
                              alt="IMG"
                              style={{
                                maxWidth: "50%",
                                width: "100%",
                                height: "fit-content",
                              }}
                              loading="lazy"
                              src={image}
                            ></img>
                          )}
                        </figure>
                        <p
                          style={{
                            textAlign: "center",
                            width: "100%",
                            margin: "10px 0 10px 0",
                          }}
                        >
                          {content}
                        </p>
                      </div>
                    </>
                  )}
                  {TypeOfText[role] === "ol" && (
                    <>
                      {/* <ol style={{ listStyle: "inherit", indentLevel: "60px", paddingLeft: "20px", marginBottom: "0", fontSize: "16px", marginLeft:"12px" }} > */}
                      <li
                        class="li_style"
                        style={{
                          marginBottom: "0.5rem",
                          padding: "5px 0 5px 0",
                        }}
                      >
                        {content}
                      </li>
                      {/* </ol> */}
                    </>
                  )}
                  {TypeOfText[role] === "video" && (
                    <>
                      <div
                        style={{ textAlign: "center", padding: "5px 0 5px 0" }}
                      >
                        <iframe alt="IMG" src={content} />
                      </div>
                    </>
                  )}
                  {TypeOfText[role] === "html" && (
                    <>
                      <HtmlBody
                        content={content}
                        fontSize={this.state.styles[role].fontSize}
                        textIndent={
                          String(this.state.styles[role].indentLevel) + "px"
                        }
                      />
                    </>
                  )}
                  {TypeOfText[role] === "mix" && (
                    <>
                      <HTML content={content} />
                    </>
                  )}
                </>
              )
            )}
            <span class="br"></span>
            <h3 style={{ fontWeight: "450", fontSize: "22px" }}>References</h3>
            <br />
            <React.Fragment>
              <ol
                style={{
                  content: "• ",
                  listStyle: "inherit",
                  indentLevel: "5px",
                  paddingLeft: "20px",
                  fontSize: "16px",
                }}
              >
                {Array.from(this.state.citation).map(({ text }) => (
                  <>
                    <li
                      className="list-item"
                      style={{
                        content: "• ",
                        display: "list-item",
                        marginBottom:"2em",
                        padding: "5px 0 5px 0",
                        wordWrap: "break-word",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {text}
                    </li>
                  </>
                ))}
              </ol>
            </React.Fragment>
          </>
        )}
        <div
          style={{
            width: "100%",
            paddingBottom: "10px",
            height: "fit-content",
            display: "flex",
            flexDirection: "row",
            paddingTop: "10px",
          }}
        >
          {previous && (
            <a
              style={{
                width: "50%",
                alignItems: "start",
                alignContent: "start",
                textAlign: "start",
                fontWeight: "bold",
              }}
              href={"/" + previous}
            >
              {previous_title}
            </a>
          )}
          {next && (
            <a
              style={{
                width: "50%",
                alignItems: "end",
                alignContent: "end",
                textAlign: "end",
                fontWeight: "bold",
              }}
              href={"/" + next}
            >
              <p>{next_title ? next_title : ""}</p>
            </a>
          )}
          <span class="br"></span>
        </div>
        <br />
        <div style={{ fontWeight: "bold" }}>
          Số lược xem: {this.state.views}
        </div>
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            paddingTop:"1em",
            paddingBottom:"1em",
          }}
        >
          <p style={{ height: "40px" }}>
            <FacebookShareButton
              url={"https://www.example.com"} //eg. https://www.example.com
              quotes={"quotes"} //"Your Quotes"
              hashtag={"#hashTag"} // #hashTag
              style={{
                height: "60px",
                maxHeight: "60px",
                alignContent: "center",
                alignItems: "center",
                display: "flex",
                margin: "0.5rem",
              }}
            >
              <FacebookIcon
                style={{
                  margin: "5px",
                  maxWidth: "30px",
                  maxHeight: "30px",
                  borderRadius: "50%",
                  margin: "0.5rem 0 0.5rem 0",
                }}
              />
            </FacebookShareButton>
          </p>
          <p style={{ height: "40px" }}>
            <TwitterShareButton
              url={"https://www.example.com"}
              title={"quotes"}
              style={{
                height: "60px",
                maxHeight: "60px",
                alignContent: "center",
                alignItems: "center",
                display: "flex",
                margin: "0.5rem",
              }}
            >
              <TwitterIcon
                style={{
                  margin: "5px",
                  maxWidth: "30px",
                  maxHeight: "30px",
                  borderRadius: "50%",
                  margin: "0.5rem 0 0.5rem 0",
                }}
              />
            </TwitterShareButton>
          </p>
        </div>
      </>
    );
  }
}

export default Post1;
